/**
 * Terms of Service Translations Module (Japanese)
 * 
 * @module terms
 * @language ja
 */

export const terms = {
  pageTitle: "利用規約",
  heroSubtitle: "プラットフォームをご利用いただく前に、本規約をよくお読みください。",
  lastUpdated: "最終更新日：2026年1月",
  effectiveDate: "発効日：2026年1月1日",

  intro: {
    title: "はじめに",
    welcome: "JCI開発評議会ユースフューチャーズ・オブザーバトリー（以下「プラットフォーム」）へようこそ。本利用規約（以下「規約」）は、プラットフォームへのアクセスおよび使用を規定します。",
    acceptance: "本プラットフォームにアクセスまたは使用することにより、お客様は本規約に拘束されることに同意したものとみなされます。本規約に同意されない場合は、プラットフォームを使用しないでください。",
    modifications: "当社は、本規約をいつでも変更することができます。変更後も引き続きプラットフォームを使用することで、変更された規約に同意したものとみなされます。",
  },

  eligibility: {
    title: "利用資格",
    age: "本プラットフォームを使用するには、18歳以上である必要があります。プラットフォームを使用することにより、お客様はこの年齢要件を満たしていることを表明し保証します。",
    membership: "プラットフォームは一般に公開されていますが、特定の機能はJCI会員または登録ユーザーに制限される場合があります。",
    accuracy: "お客様は、登録時に正確で最新かつ完全な情報を提供し、その情報を維持・更新することに同意します。",
  },

  account: {
    title: "アカウントの責任",
    security: "お客様は、アカウント資格情報の機密性を維持し、アカウントで発生するすべての活動について責任を負います。",
    notification: "アカウントの不正使用またはその他のセキュリティ違反を発見した場合は、直ちに当社に通知する必要があります。",
    prohibition: "アカウント資格情報を他者と共有したり、他者がお客様のアカウントを使用してプラットフォームにアクセスすることを許可したりすることはできません。",
  },

  acceptableUse: {
    title: "許容される使用",
    description: "お客様は、本規約に従い、合法的な目的にのみプラットフォームを使用することに同意します。",
    prohibited: "禁止事項：",
    item1: "違法または無許可の目的でプラットフォームを使用すること",
    item2: "システム、ネットワーク、またはデータへの不正アクセスを試みること",
    item3: "プラットフォームまたは接続されたサーバーやネットワークを妨害または中断させること",
    item4: "自動化された手段を使用してプラットフォームにアクセスしたりデータを収集したりすること",
    item5: "ウイルス、マルウェア、その他の有害なコードを送信すること",
    item6: "他人や組織になりすましたり、所属を偽ったりすること",
    item7: "同意なく他のユーザーの個人情報を収集すること",
    item8: "スパム、フィッシング、または詐欺行為にプラットフォームを使用すること",
  },

  intellectualProperty: {
    title: "知的財産権",
    jciTrademarks: "JCI、Junior Chamber International、JCIロゴ、および関連するすべての商標、サービスマーク、ロゴは、Junior Chamber Internationalの財産です。書面による事前の許可なく、これらのマークを使用することはできません。",
    dataLicense: "本プラットフォーム上のデータ、ビジュアライゼーション、およびコンテンツは、特に明記されていない限り、クリエイティブ・コモンズ 表示-非営利-継承 4.0 国際ライセンス（CC BY-NC-SA 4.0）の下で提供されます。",
    restrictions: "明示的な書面による許可なく、商業目的で当社の知的財産を使用することはできません。",
    platformCredits: "本プラットフォームは、DashCityがJCI開発評議会と提携して開発・維持しています。",
  },

  dataPrivacy: {
    title: "データとプライバシー",
    reference: "プラットフォームのご利用は、お客様の個人情報の収集、使用、保護方法を説明するプライバシーポリシーにも準拠します。",
    link: "当社のデータ取り扱いについては、プライバシーポリシーをご確認ください。",
    gdpr: "当社はGDPR遵守に尽力し、お客様のデータ保護権を尊重します。",
  },

  thirdParty: {
    title: "第三者サービス",
    description: "本プラットフォームには、当社が所有または管理していない第三者のウェブサイトまたはサービスへのリンクが含まれている場合があります。",
    disclaimer: "当社は、第三者のウェブサイトまたはサービスのコンテンツ、プライバシーポリシー、または慣行について管理権を持たず、責任を負いません。",
    acknowledgment: "お客様は、第三者のコンテンツ、商品、またはサービスの使用に起因または関連して生じた損害または損失について、当社が責任を負わないことを認め、同意します。",
  },

  disclaimers: {
    title: "免責事項",
    asIs: "本プラットフォームは「現状のまま」かつ「利用可能な状態で」提供され、明示的または黙示的を問わず、いかなる種類の保証もありません。",
    noWarranty: "当社は、プラットフォームが中断されず、安全で、エラーがないこと、または欠陥が修正されることを保証しません。",
    accuracy: "当社は正確なデータと情報の提供に努めていますが、プラットフォーム上のコンテンツの正確性、完全性、または信頼性について保証しません。",
    research: "提供されるデータと洞察は情報提供のみを目的としており、意思決定の唯一の根拠とすべきではありません。",
  },

  responsibilities: {
    title: "お客様の責任",
    description: "お客様は、プラットフォームの使用について責任を負い、本規約およびすべての適用法に従って使用することに同意します。プラットフォームの不正使用はアクセス権の停止につながる場合があることをご理解ください。",
  },

  governingLaw: {
    title: "準拠法",
    jurisdiction: "本規約は、適用される国際法の原則およびプラットフォームの主要業務が行われる法域の法律に準拠し、解釈されるものとします。",
    disputes: "本規約またはお客様のプラットフォーム使用に起因する紛争は、誠実な交渉により解決されます。交渉が失敗した場合、紛争は拘束力のある仲裁に提出することができます。",
    severability: "本規約のいずれかの条項が執行不能と判断された場合、残りの条項は完全な効力を維持します。",
  },

  termination: {
    title: "終了",
    byUs: "当社は、理由の有無にかかわらず、通知の有無にかかわらず、いつでもお客様のプラットフォームへのアクセスを終了または停止することができます。",
    byYou: "お客様はいつでもプラットフォームの使用を停止できます。アカウントをお持ちの場合は、設定ページから削除できます。",
    survival: "その性質上、終了後も存続すべき条項は、知的財産権に関する条項、免責事項、および責任の制限を含め、存続するものとします。",
  },

  contact: {
    title: "お問い合わせ",
    description: "本利用規約についてご質問がある場合は、お問い合わせください：",
    email: "メール：tmariano@jci.cc",
    response: "すべてのお問い合わせには5営業日以内に回答するよう努めています。",
  },
} as const;
